export const getState = (state = {}) => state;
export const getLanguage = store => getState(store).language;
export const getTimeFormat = store => getState(store).timeFormat;
export const getOddFormat = store => getState(store).oddFormat;
export const getTimeZone = store => getState(store).timeZone;
export const getSound = store => getState(store).sound;
export const getPreference = (store, key) => getState(store)[key];
